import { Component, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { State } from '../../+state/selectors';
import * as fromRoot from '../../+state/selectors';

@Component({
  selector: 'drp-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
export class ModalComponent implements OnInit {
  modalOpen = false;
  errors: Observable<any>;
  statusCode: string;
  statusText: string;
  constructor(
    private renderer: Renderer2,
    private store: Store<State>
  ) {}

  ngOnInit() {
    this.errors = this.store.select(fromRoot.getErrors);
    this.errors.subscribe(err => {
      if (
        err.length > 0 &&
        (err[0].status === 405 || err[0].status === 500 || err[0].status === 502)
      ) {
        this.statusCode = err[0].status;
        this.statusText = err[0].statusText;
        this.openTheModal();
      }
    });
  }

  openTheModal() {
    this.modalOpen = true;
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
  }

  closeTheModal() {
    this.modalOpen = false;
    this.renderer.removeStyle(document.body, 'overflow');
  }
}
